import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const { user } = useAuth();
  const [dark, setDark] = useState(() => {
    const stored = localStorage.getItem("dark_mode");
    if (stored != null) return stored === "true";
    return false;
  });

  useEffect(() => {
    // Sync from user preference on login
    if (user && typeof user.dark_mode === "boolean") {
      setDark(user.dark_mode);
      localStorage.setItem("dark_mode", String(user.dark_mode));
    }
  }, [user?.id]); // eslint-disable-line

  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("dark_mode", String(dark));
  }, [dark]);

  const toggle = async () => {
    const next = !dark;
    setDark(next);
    if (user) {
      try { await api.patch("/auth/preferences", { dark_mode: next }); } catch (e) { /* ignore */ }
    }
  };

  return (
    <ThemeContext.Provider value={{ dark, toggle }}>{children}</ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
